<p-button
  label="¿Cómo veo mi lectura?"
  icon="pi pi-search"
  severity="info"
  [text]="true"
  (onClick)="open()"
/>

<p-dialog
  header="¿Cómo veo mi lectura?"
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [breakpoints]="{ '960px': '90vw', '576px': '96vw' }"
  [style]="{ width: 'min(780px, 95vw)' }"
  styleClass="send-reading-help-dialog"
>
  <div class="help-content">
    @if (selectedType(); as type) {
      <div class="detail-toolbar">
        <p-button
          label="Volver a tipos"
          icon="pi pi-arrow-left"
          severity="secondary"
          [text]="true"
          (onClick)="clearSelection()"
        />
      </div>

      <article class="type-detail">
        <header class="detail-header">
          <h3>{{ type.title }}</h3>
          <p class="detail-subtitle">{{ type.subtitle }}</p>
        </header>

        <figure class="help-figure">
          <img
            [ngSrc]="type.imageSrc"
            [width]="type.width"
            [height]="type.height"
            [alt]="type.title + ': ejemplo de lectura'"
            class="help-image"
            priority
          />
        </figure>

        <ul class="help-points">
          @for (paragraph of type.helpParagraphs; track paragraph) {
            <li>{{ paragraph }}</li>
          }
        </ul>

        <p class="help-link-block">
          Más detalle en el blog de Gomez Group Metering:
          <a [href]="blogUrl" target="_blank" rel="noopener noreferrer">
            ¿Quieres saber cómo leer un contador de agua?
          </a>
        </p>
      </article>
    } @else {
      <p class="help-intro">
        Selecciona el tipo de contador que tienes. Anota solo los
        <strong>metros cúbicos (m³)</strong>; no debes incluir los litros.
      </p>

      <div class="type-grid" role="list">
        @for (meterType of meterTypes(); track meterType.id) {
          <button
            type="button"
            class="type-card"
            role="listitem"
            (click)="selectType(meterType.id)"
            [attr.aria-label]="'Ver ayuda de ' + meterType.title + ', ' + meterType.subtitle"
          >
            <img
              [ngSrc]="meterType.imageSrc"
              [width]="meterType.width"
              [height]="meterType.height"
              [alt]="meterType.title + ' (' + meterType.subtitle + ')'"
              class="type-card-image"
            />
            <span class="type-card-title">{{ meterType.title }}</span>
            <span class="type-card-subtitle">{{ meterType.subtitle }}</span>
          </button>
        }
      </div>
    }
  </div>
</p-dialog>
